import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createLDESubmittal, updateLDEQuotation } from 'src/_helpers/api';

const name = 'ldeSubmittals';

const initialState = {
  ldeSubmittals: [],
  error: null,
};

const addLDESubmittalAsync = createAsyncThunk(`${name}/add-lde-submittal`, async (submittalData, { rejectWithValue }) => {
  try {
    const response = await createLDESubmittal(submittalData);
    //console.log('🚀 ~ API response received:', response);
    return response;
  } catch (error) {
    //console.error('🚀 ~ Error occurred in addSubmittalAsync:', error);
    return rejectWithValue(error.response ? error.response.data : 'Unknown error');
  }
});

const updateLDESubmittalAsync = createAsyncThunk(`${name}/update-lde-submittal`, async (submittalData) => {
  console.log('🚀 ~ submittalData:', submittalData)
  return await updateLDEQuotation(submittalData)
})

const ldeSubmittalSlice = createSlice({
  name,
  initialState,
  reducers: {
    resetState: (state) => {
      state.ldeSubmittals = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addLDESubmittalAsync.pending, (state) => {
        state.error = null;
      })
      .addCase(addLDESubmittalAsync.fulfilled, (state, action) => {
        state.ldeSubmittals.push(action.payload);
      })
      .addCase(addLDESubmittalAsync.rejected, (state, action) => {
        state.error = action.error;
      })
      .addCase(updateLDESubmittalAsync.pending, (state) => {
        state.error = null;
      })
      .addCase(updateLDESubmittalAsync.fulfilled, (state, action) => {
        const index = state.ldeSubmittals.findIndex(s => s.id === action.payload.id);
        if (index !== -1) state.ldeSubmittals[index] = action.payload;
      })
      .addCase(updateLDESubmittalAsync.rejected, (state, action) => {
        state.error = action.error;
      });
  },
});

export const ldeSubmittalActions = {
  ...ldeSubmittalSlice.actions,
  addLDESubmittalAsync,
  updateLDESubmittalAsync,
};

export const ldeSubmittalsReducer = ldeSubmittalSlice.reducer;
